import {IconButton} from 'platform/components';
import {Heading, HStack, useDevice, Show, Box, Space} from 'platform/foundation';
import styled, {css} from 'styled-components';

import {ReactNode} from 'react';

import {or} from 'ramda';

import {ActivitySidebarAction} from '../types/ActivitySidebarAction';
import {ActivitySidebarMenu} from './ActivitySidebarMenu';
import {MOBILE_ACTIVITY_MENU_HEIGHT} from './MOBILE_ACTIVITY_MENU_HEIGHT';

interface ActivitySidebarItemV2Props {
  title: string;
  onClose: () => void;
  children: ReactNode;
  disablePadding?: boolean;
  actions: ActivitySidebarAction[];
  handleToggleTab: (tabId: string) => void;
  activeTab: string | null;
}

export function ActivitySidebarItemV2(props: ActivitySidebarItemV2Props) {
  const device = useDevice();
  const isMobileOrTablet = or(device === 'mobile', device === 'tablet');
  return (
    <ActivityBoxV2 $isMobileOrTablet={isMobileOrTablet}>
      <Header data-testid="activity-sidebar-item-header">
        <HStack spacing={4} justify="space-between" align="center">
          <Heading size={4}>{props.title}</Heading>
          <IconButton icon="navigation/close" onClick={props.onClose} />
        </HStack>
      </Header>
      <ContentArea $disablePadding={props.disablePadding}>{props.children}</ContentArea>
      <Show when={isMobileOrTablet}>
        <Space vertical={MOBILE_ACTIVITY_MENU_HEIGHT} />
        <Box position="fixed" bottom={0} left={0} right={0}>
          <ActivitySidebarMenu
            actions={props.actions}
            onClick={props.handleToggleTab}
            activeTab={props.activeTab}
          />
        </Box>
      </Show>
    </ActivityBoxV2>
  );
}

const ActivityBoxV2 = styled.div<{$isMobileOrTablet: boolean}>`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  align-self: ${({$isMobileOrTablet}) => ($isMobileOrTablet ? 'stretch' : 'flex-start')};
`;

const Header = styled.div`
  flex-shrink: 0;
  padding: ${({theme}) => theme.getSize(4)};
  border-bottom: 1px solid ${({theme}) => theme.colors.general.separator};
`;

interface ContentAreaProps {
  $disablePadding?: boolean;
}

const ContentArea = styled.div<ContentAreaProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  ${({theme, $disablePadding}) =>
    !$disablePadding &&
    css`
      padding: ${theme.getSize(4)};
    `}
`;
